/* Open/close for the 2026 PDP details drawer (snippets/pdp2026-details-drawer).

   A separate file from pdp2026-drawers.js on purpose. That one still loads --
   it portals the size guide, which nothing here touches -- and it stays
   byte-identical so the previous drawer behaves exactly as it does today if
   the section is pointed back at it for the A/B test. Its click handlers look
   for `.pdp2026-drawers .drawer--opener--one`; this markup renders no such
   class, so the two never both fire.

   Delegated from document, so the drawer surviving or being replaced by a
   section re-render on a variant change needs no re-binding. */
(function () {
  if (window.Pdp2026DetailsDrawer) return;

  var OPEN = 'is-open';
  var PORTAL_ID = 'pdp2026-dd-portal';

  function panels() {
    return document.querySelectorAll('[data-pdp2026-dd-panel]');
  }

  function scrims() {
    return document.querySelectorAll('[data-pdp2026-dd-scrim]');
  }

  function header() {
    return document.querySelector('.section-header.shopify-section-group-header-group');
  }

  /* The drawer is rendered inside product-info's sticky column, which is
     `position: sticky; z-index: 2` -- a stacking context. A fixed descendant
     cannot escape it, so however high the panel's z-index goes it is still
     painted at level 2 and the sticky site header (z-index 1000) covers its
     title. Moving the nodes to <body> is the fix the rest of this theme
     already uses for the same reason. */
  function portalRoot() {
    var root = document.getElementById(PORTAL_ID);
    if (!root) {
      root = document.createElement('div');
      root.id = PORTAL_ID;
      document.body.appendChild(root);
    }
    return root;
  }

  function portal() {
    var root = portalRoot();
    var fresh = [];
    var nodes = document.querySelectorAll('[data-pdp2026-dd-panel], [data-pdp2026-dd-scrim]');

    for (var i = 0; i < nodes.length; i++) {
      /* Only nodes still sitting where Liquid put them. A section re-render
         produces a fresh set beside the ones already moved, so finding any
         here means the portal holds a stale copy -- empty it before refilling.
         Finding none means everything is in place and this is a no-op. */
      if (!root.contains(nodes[i])) fresh.push(nodes[i]);
    }
    if (!fresh.length) return;

    root.replaceChildren();
    for (var j = 0; j < fresh.length; j++) root.appendChild(fresh[j]);
  }

  function closeAll() {
    panels().forEach(function (panel) {
      panel.classList.remove(OPEN);
    });
    scrims().forEach(function (scrim) {
      scrim.classList.remove(OPEN);
    });
    var head = header();
    if (head) head.classList.remove('product--info--drawer--open--now');
    document.body.classList.remove('scroll_lock');
  }

  function open(name) {
    portal();
    var panel = document.querySelector('[data-pdp2026-dd-panel="' + name + '"]');
    if (!panel) return;

    panels().forEach(function (other) {
      other.classList.remove(OPEN);
    });
    panel.classList.add(OPEN);
    scrims().forEach(function (scrim) {
      scrim.classList.add(OPEN);
    });

    var head = header();
    if (head) head.classList.add('product--info--drawer--open--now');
    document.body.classList.add('scroll_lock');

    var close = panel.querySelector('[data-pdp2026-dd-close]');
    if (close) close.focus();
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var trigger = target.closest('[data-pdp2026-dd-open]');
    if (trigger) {
      open(trigger.getAttribute('data-pdp2026-dd-open'));
      return;
    }
    if (target.closest('[data-pdp2026-dd-close]') || target.closest('[data-pdp2026-dd-scrim]')) {
      closeAll();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll();
  });

  document.addEventListener('shopify:section:load', portal);

  window.Pdp2026DetailsDrawer = { open: open, close: closeAll, portal: portal };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', portal);
  } else {
    portal();
  }
})();
